import React from "react";
import { Tag } from "antd";
import { useSelector } from "react-redux";

import { googleAds } from "appConfig";

import { getWindowWidth, isSearchMobile } from "./../../services";
import { buildBaseUrl } from "../../services/utils";
import { getIconUrl } from "../../services/asset";
import { PageRoute } from "../../models";
import history from "../../history";
import styles from "./LeftMenu.scss";
import { selectLoadedUser } from "../../routes/Auth/auth.ducks";
import { selectUnreadCount } from "../../routes/Chat/chat.ducks";
import { selectSystemMessageUnreadCount } from "../../routes/SystemMessage/systemMessage.ducks";
import GoogleAd from "../GoogleAd";
import GoogleAdInterstitial from "../GoogleAdInterstitial";

const LOGOUT = "logout";

const menuConfigs = [
  {
    key: PageRoute.myAd,
    icon: "moji-oglasi.svg",
    label: "Moji oglasi"
  },
  {
    key: PageRoute.chats,
    icon: "poruke.svg",
    label: "Poruke"
  },
  {
    key: PageRoute.myRatings,
    icon: "ocjene.svg",
    label: "Ocjene"
  },
  {
    key: PageRoute.favorite,
    icon: "spremljeni-oglasi.svg",
    label: "Spremljeni oglasi"
  },
  {
    key: PageRoute.savedSearch,
    icon: "moje-pretrage.svg",
    label: "Moje pretrage"
  },
  {
    key: PageRoute.finance,
    icon: "financije.svg",
    label: "Financije"
  },
  {
    key: PageRoute.credits,
    icon: "krediti.svg",
    label: "Krediti"
  },
  {
    key: PageRoute.profile,
    icon: "moji-podaci.svg",
    label: "Moji podaci"
  },
  {
    key: PageRoute.settings,
    icon: "postavke.svg",
    label: "Postavke"
  },
  {
    key: PageRoute.changePassword,
    icon: "lozinka.svg",
    label: "Lozinka"
  },
  {
    key: LOGOUT,
    icon: "odjava.svg",
    label: "Odjava"
  }
]


const LeftMenu = ({ children, activeKey, showGoogleAd = true }: any) => {
  const chatUnreadCount = useSelector(selectUnreadCount);
  const systemUnreadCount = useSelector(selectSystemMessageUnreadCount);
  const unreadCount = (chatUnreadCount || 0) + (systemUnreadCount || 0);
  const user = useSelector(selectLoadedUser);


  const onChange = (key: string) => {
    // enable redirecting from single chat page to chats list
    const params = new URLSearchParams(history.location.search);
    const adId = params.get("adId");
    const chatId = params.get("chatId");
    if (key === activeKey && history.location.pathname === PageRoute.chats && (chatId || adId)) {
      history.push(PageRoute.chats);
      return;
    }

    if (key === LOGOUT) {
      handleLogout();
    } else {
      history.push(key);
    }
  };


  const handleLogout = () => {
    window.location.replace(buildBaseUrl("/authentication/logout"));
  };

  const isMobile = isSearchMobile(getWindowWidth());

  return (
    <React.Fragment>
      {isMobile && (
        <GoogleAdInterstitial
          config={{
            ...googleAds.interstitialSlot,
            id: "googleAds.interstitialSlot"
          }}
        />
      )}
      {!user ? (
        <div className={`ads-container ${styles.container}`}>{children}</div>
      ) : (
        <div className="left-menu">
          <div className={styles.sidebarWrapper}>
            <div className={styles.sidebarColumn}>
              <div className={styles.sidebar}>
                {menuConfigs
                  .filter(item => {
                    if ((item.key === PageRoute.credits || item.key === PageRoute.finance) && !user.isVerified) {
                      return false;
                    }
                    return true;
                  })
                  .map(item => (
                    <div
                      key={item.key}
                      className={`${styles.sidebarItem} ${activeKey === item.key ? styles.sidebarItemActive : ''}`}
                      onClick={() => onChange(item.key)}
                    >
                      <div className={styles.menuTabContent}>
                        <img alt={item.label} src={getIconUrl(item.icon)} className={styles.icon} />
                        <span>{item.label}</span>
                        {item.key === PageRoute.credits && (
                          <Tag className={styles.tag}>{user.storeCreditBalance}</Tag>
                        )}
                        {item.key === PageRoute.chats && unreadCount > 0 && (
                          <Tag className={styles.tag}>{unreadCount}</Tag>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
              {!isMobile && showGoogleAd && (
                <div style={{ marginTop: 15 }}>
                  <GoogleAd
                    className={styles.ads}
                    config={{
                      ...googleAds.profilePage.left,
                      id: "googleAds.profilePage.left"
                    }}
                  />
                </div>
              )}
            </div>
            <div className={styles.contentArea}>
              {children}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

LeftMenu.defaultProps = {
  children: null,
  user: null
};


export default LeftMenu;



// WEBPACK FOOTER //
// ./src/components/LeftMenu/index.tsx